// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"226":"122d8dca","827":"91adf2ea"}[chunkId] + ".chunk.css";
};